/**
* file : TournamentRelated/Common/RealRanking.jsx
* 설명 : 실시간 랭킹
*/

import { Fnc } from "common/globals";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SSE } from 'components/Common/ApiCall';
import { useEffect, useState, useRef } from 'react';

export default function RealRanking( props ) {
  // 접속자 토큰 정보
  const { token } = useSelector(state => state.Client);
  // 토큰 정보 추출
  const info = Fnc.TokenSubstitution(token.access_token);
  // 데이터
  const [datas, setData] = useState();
  // 리스트 갯수
  const [listCount, setListCount] = useState(10)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 10
    setListCount(count);
  }
  // 조회 조건
  const searchWhereRef = useRef({});
  // 조회 조건 할당
  const searchWherePut = (key, val) => {
    props.setDataLoading(true)
    searchWhereRef.current = { ...searchWhereRef.current, [key]: val }
  };
  // SSE 통신
  useEffect(() => {
    const { start, stop } = SSE();
    
    start(`/ranking?tournament_idx=${props.tournament_idx}`, 
    (result) => {
        const { user_idx } = searchWhereRef.current;
        if (!Fnc.Empty(user_idx)) result = result.filter((item) => item.user_idx === user_idx);
        
        setData(result);
        props.setDataLoading(false);
    }, (err) => {
      console.error('SSE Ranking 통신 중 오류:', err);
      props.setDataLoading(false);
    })

    return () => {
      stop();
    };
  }, []);
  
  return(
    <div className="zeus-tab-item tab-show">
      <div className="search_box margin-bottom-10 justify-content-end">
        <div className="check__" >
          <input id="realRanking" type="checkbox" onChange={(e) => searchWherePut('user_idx', e.target.checked ? info.idx : '')}/>
          <label htmlFor="realRanking"><span className="color-white">나의 순위 보기</span></label>
        </div>
      </div>
      <div className="table-container">
        <table className="table_style1">
          <thead>
            <tr>
              <th>랭킹</th>
              <th>회원 ID</th>
              <th>보유 금액</th>
              <th>누적 베팅 금액</th>
              <th>누적 당첨 금액</th>
              <th>상금금액</th>
            </tr>
          </thead>
          <tbody>
            {
              (!Fnc.Empty(datas)) && datas.slice(0, listCount).map((data, index) => (
                <tr key={index}>
                  <td>{data.rank}</td>
                  <td>
                    {data.user_id}
                    {data.user_idx === info.idx && <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -910 960 960" width="25px" fill="#0D7EE7"><path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" /></svg>}
                  </td>
                  <td className="align_r font_style1"><span className="won"></span>{data.held_money.toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{data.bet_money.toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{data.win_money.toLocaleString()}</td>
                  <td className="align_r txt_org font_style1"><span className="won txt_org"></span>{Number(data.prize_money).toLocaleString()}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
        { Fnc.Empty(datas) && <div className='table-no-data'>랭킹 내역이 존재하지 않아요</div> }
        {
          !Fnc.Empty(datas) &&
          listCount < datas.length && (
            <div className="btns_wrap mt_30 mb_30">
              <Link className="btn_more" onClick={showMore}>더불러오기</Link>
            </div>
          )
        }
      </div>
    </div>
  )
}